/* eslint-disable no-param-reassign */
export const SET_IS_OFFER_ADDRESS_AUTO_COMPLETE_DISABLED = 'set-is-offer-address-auto-complete-disabled';

export default {
  [SET_IS_OFFER_ADDRESS_AUTO_COMPLETE_DISABLED](state, value) {
    state.isOfferAddressAutoCompleteDisabled = value;
  },
};
